// extracted by mini-css-extract-plugin
module.exports = {"section":"DTIProductCards_section__1zLRD","subtitle":"DTIProductCards_subtitle__86oUx","product-card-carousel":"DTIProductCards_product-card-carousel__Y1uwg"};